(function () {
  var LABELS = {
    'de': 'Erforderlich',
    'en': 'Required',
    'fr': 'Obligatoire',
    'nl': 'Verplicht',
    'es': 'Obligatorio',
    'it': 'Obbligatorio',
    'pt': 'Obrigatório',
    'pl': 'Wymagane',
    'da': 'Påkrævet',
    'sv': 'Obligatoriskt',
    'nb': 'Obligatorisk',
    'fi': 'Pakollinen',
    'cs': 'Povinné',
    'hu': 'Kötelező',
    'ro': 'Obligatoriu',
    'tr': 'Zorunlu'
  };

  var lang = ((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'de')
    .split('-')[0].toLowerCase();
  var label = LABELS[lang] || LABELS['de'];

  function fixLabels() {
    document.querySelectorAll('.customily-required-label > span').forEach(function (span) {
      if (span.style.color && span.textContent.trim()) {
        span.textContent = label;
      }
    });
  }

  function init() {
    var root = document.getElementById('customily-options')
      || document.getElementById('customily-personalize-accordion');
    if (!root) return;

    new MutationObserver(fixLabels).observe(root, { childList: true, subtree: true });

    var atcBtn = document.getElementById('customily-cart-btn');
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        setTimeout(fixLabels, 50);
        setTimeout(fixLabels, 300);
        setTimeout(fixLabels, 800);
      });
    }

    fixLabels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
